/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentMethodStatus } from "./PaymentMethodStatus";
import { PaymentMethodManagementType } from "./PaymentMethodManagementType";
import { Range } from "./Range";
import * as t from "io-ts";

/**
 * Payment method Response
 */

/**
 * Brand assets map associated to the selected payment method
 */

// additional attributes

export const PaymentMethodResponseBrandAssets = t.record(
  t.string,

  t.string,

  "PaymentMethodResponseBrandAssets"
);

export type PaymentMethodResponseBrandAssets = t.TypeOf<
  typeof PaymentMethodResponseBrandAssets
>;

// required attributes
const PaymentMethodResponseR = t.interface({
  id: t.string,

  name: t.string,

  description: t.string,

  status: PaymentMethodStatus,

  paymentTypeCode: t.string,

  methodManagement: PaymentMethodManagementType,

  ranges: t.readonlyArray(Range, "array of Range")
});

// optional attributes
const PaymentMethodResponseO = t.partial({
  asset: t.string,

  brandAssets: PaymentMethodResponseBrandAssets
});

export const PaymentMethodResponse = t.intersection(
  [PaymentMethodResponseR, PaymentMethodResponseO],
  "PaymentMethodResponse"
);

export type PaymentMethodResponse = t.TypeOf<typeof PaymentMethodResponse>;
